export const StorageKeys = {
  token: "LABOSHOP_ADMIN_TOKEN",
  userContext: "LABOSHOP_ADMIN_USER",
};
